import styled from 'styled-components';

export const Container = styled.p`
  font-size: 11px;
  color: #f78e1e !important;

  margin-bottom: 0;
  padding: 0px 2px 16px 2px;
`;
